import { isUpcomingAppointment } from '@avanta/shared/utils/appointments';
import { type Appointment } from 'types/appointments';

export const isCompletedAppointment = (
  appointment: Pick<Appointment, 'canceled' | 'dateTime' | 'sessionDetails'>
): boolean => !appointment.canceled && !isUpcomingAppointment(appointment);
